import {get} from 'lodash';

export default (state = {}, {orderId, order}: any) => {
  return {
    ...state,
    allOrderDetail: {
      ...get(state, 'allOrderDetail', {}),
      [orderId]: order,
    },
  };
};
